import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import overrideStyle from 'lib/overrideStyle';

import { LOCATIONS } from 'app/modules/ui/constants';
import { navigateForward } from 'app/modules/ui/actions';
import { quickActionTypes } from 'app/modules/self_service/constants';
import { updateSelectedAnswer } from 'app/modules/self_service';

export const StyledAnswerItem = overrideStyle('a')`
  border: 1px solid #DEDEDE;
  border-radius: 8px;
  color: black;
  cursor: pointer;
  display: block;
  font-size: 14px;
  letter-spacing: .3px;
  margin-bottom: 24px;
  outline: none;
  padding: 24px;
  text-decoration: none;
  &:visited {
    color: black;
  }
`;

class AnswerItem extends React.Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.isInternal = this.isInternal.bind(this);
  }

  isInternal() {
    const answer = this.props.answer;
    if (answer) {
      return answer.content.type === quickActionTypes.INTERNAL;
    }
    return false;
  }

  handleClick() {
    if (this.isInternal()) {
      const answer = this.props.answer;
      this.props.onClickItem(answer.content.value);
    }
  }

  render() {
    const answer = this.props.answer;
    const href = this.isInternal() ? null : answer.content.value;
    return (
      <StyledAnswerItem
        href={href}
        onMouseDown={this.handleClick}
        rel="noopener noreferrer"
        role="button"
        tabIndex="0"
        target="_blank"
      >
        {answer.name}
      </StyledAnswerItem>
    );
  }
}

AnswerItem.propTypes = {
  answer: PropTypes.object,
  onClickItem: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => {
  return {
    onClickItem: answerId => {
      dispatch(updateSelectedAnswer(answerId));
      dispatch(navigateForward(LOCATIONS.ANSWER));
    },
  };
};

export { AnswerItem };
export default connect(
  null,
  mapDispatchToProps
)(AnswerItem);
